import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';

const NotFound = () => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <div className={'container pb-168 pt-112 md:pb-296 md:pt-160'}>
      <div className={'flex flex-col items-center lg:items-start'}>
        <h1 className="body-text-2xlarge font-medium">
          {formatMessage({
            id: 'page.notFound',
            defaultMessage: 'Page not found',
          })}
        </h1>
        <p className={'body-text-large mt-16 text-center'}>
          {formatMessage({
            id: 'page.notFound.desc',
            defaultMessage:
              "The page you were looking for couldn't be found. It may have been deleted, renamed, or doesn't exist.",
          })}
        </p>
        <Link link="/" buttonVariant={'primary'} className={'mt-32'}>
          {formatMessage({ id: 'page.notFound.cta', defaultMessage: 'Go back home' })}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
